import React, { Fragment, useEffect, useState } from 'react'
import { ArrowLeftCircle } from 'iconoir-react';
import { useNavigate, useParams } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import moment from 'moment';
import FileItem from './../../components/FileItemComponent/FileItem';
import SkeletonWorkSchedule from './../../components/Skeleton/SkeletonWorkSchedule';

const CompanyWorkScheduleDetail = ({ workScheduleStore }) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const { companyWorkId } = useParams();
    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                await Promise.all([workScheduleStore.getWorkScheduleDetail(companyWorkId)]);
            } catch (err) {
                console.log(err);
            } finally {
                setLoading(false);
            }
        })();

    }, [])
    let workScheduleDetail = toJS(workScheduleStore.workScheduleDetail)
    function uppercase(str) {
        var array1 = str?.split(' ');
        var newarray1 = [];

        for (var x = 0; x < array1?.length; x++) {
            newarray1.push(array1[x].charAt(0).toUpperCase() + array1[x].slice(1));
        }
        return newarray1.join(' ');
    }

    return (
        <div className='pt-6 px-5'>
            <div className='mb-5 flex items-center'>
                <ArrowLeftCircle className='w-[24px] h-[24px] mr-5 mt-1 cursor-pointer' onClick={() => navigate(-1)} />
                <div className="font-bold text-[28px] leading-[29px]  ">
                    Lịch cơ quan
                </div>
            </div>
            {loading ? (<SkeletonWorkSchedule />) : <div className='text-sm'>
                <div className='mb-3.5'>
                    <b>Ngày thực hiện:</b>
                    <p>Ngày giao: {moment(workScheduleDetail?.start_at).format("DD-MM-YYYY")}</p>
                </div>
                <div className='mb-3.5'>
                    <b>Thời gian:</b>
                    {workScheduleDetail?.end_at === null ? <p>Bắt đầu từ {moment(workScheduleDetail?.start_at).format("LT")}</p> : <p>Bắt đầu từ {moment(workScheduleDetail?.start_at).format("LT")} tới {moment(workScheduleDetail?.end_at).format("LT")}</p>}
                </div>
                <div className='mb-3.5'>
                    <b>Chủ trì:</b>
                    <p>{workScheduleDetail?.host}</p>
                </div>
                <div className='mb-3.5'>
                    <b>Địa điểm:</b>
                    <p>
                        {workScheduleDetail.location?.indexOf('http') != -1 ? <div>{workScheduleDetail.location?.slice(0, workScheduleDetail.location?.indexOf('http'))} <a href={workScheduleDetail.location?.slice(workScheduleDetail.location?.indexOf('http'))} target="_blank">{workScheduleDetail.location?.slice(workScheduleDetail.location?.indexOf('http'))}</a></div> : <div>{workScheduleDetail.location}</div>}</p>
                </div>
                <div className='mb-3.5'>
                    <b>Chuẩn bị:</b>
                    <p>{workScheduleDetail?.preparation ? <Fragment>{workScheduleDetail?.preparation}</Fragment> : <i className='text-[#9F9F9F]'>Không có.</i>}</p>
                </div>
                <div className='mb-3.5'>
                    <b>Nội dung sự kiện:</b>
                    <p>{workScheduleDetail.event_notice ? <p dangerouslySetInnerHTML={{ __html: workScheduleDetail?.event_notice }} /> : <i className='text-[#9F9F9F]'>Không có.</i>}</p>
                </div>
                <div className='mb-3.5'>
                    <b>Tài liệu đính kèm:</b>
                    <p>{workScheduleDetail.file_ids?.length > 0 ? <Fragment>
                        {workScheduleDetail.file_ids.map(file => {
                            let file_id = file.file_id;
                            let file_title = file.file_title;
                            let index = file.file_type?.indexOf('/') + 1
                            let file_type = file.file_type?.slice(index);
                            return <FileItem file_id={file_id} file_name={file_title} file_type={file_type} />
                        })}
                    </Fragment> : <i className='text-[#9F9F9F]'>Không có.</i>}</p>
                </div>
                <div className='mb-3.5'>
                    <b>Thành viên tham gia:</b>
                    <p>{workScheduleDetail.attenders ? <Fragment>{uppercase(workScheduleDetail.attenders?.toLowerCase())}</Fragment> : <i className='text-[#9F9F9F]'>Không có.</i>}</p>
                </div>
                <div className='mb-3.5'>
                    <b>Thông báo:</b>
                    <p className='flex'>{workScheduleDetail.assignees?.length > 1 ? <Fragment>
                        {workScheduleDetail.assignees?.map((item, index) => {
                            return <Fragment>
                                {item.permission === 'VIEW' ? <div key={index} className='mr-2'>
                                    {uppercase(item.name_uppercase?.toLowerCase())}
                                </div> : ''}
                            </Fragment>
                        })}</Fragment> : <i className='text-[#9F9F9F]'>Không có.</i>}</p>
                </div>
                <div className='mb-3.5'>
                    <b>Ngày tạo:</b>
                    <p className='flex'>{workScheduleDetail.assignees?.map((item, index) => {
                        return <Fragment>
                            {item.permission === 'CREATE' ? <div key={index} className='mr-2'>
                                {uppercase(item.name_uppercase?.toLowerCase())}
                            </div> : ''}
                        </Fragment>
                    })} - {moment(workScheduleDetail?.created_at).format("DD-MM-YYYY LT")}</p>
                </div>
                <div className='mb-3.5'>
                    <b>Chỉnh sửa lần cuối:</b>
                    <p>{workScheduleDetail.last_edit_by ? <Fragment>
                        {uppercase(workScheduleDetail.last_edit_by?.name_uppercase?.toLowerCase())} - {moment(workScheduleDetail?.updated_at).format("DD-MM-YYYY LT")}
                    </Fragment> : <i className='text-[#9F9F9F]'>Không có.</i>}</p>
                </div>
            </div>}


        </div>
    )
}

export default inject("workScheduleStore")(observer(CompanyWorkScheduleDetail));
